/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { DataProvider } from 'react-admin'
import { DataProvidersResource } from './type'

export default (dataProviders: DataProvidersResource[]): DataProvider => {
  const getDataProvider = (resource: string): DataProvider => {
    return dataProviders.find((item) => item.resources.includes(resource)).dataProvider
  }
  return {
    getList: async (resource, params) => {
      return getDataProvider(resource).getList(resource, params)
    },
    getOne: async (resource, { id }) => {
      return getDataProvider(resource).getOne(resource, { id })
    },
    getMany: async (resource, { ids }) => {
      return getDataProvider(resource).getMany(resource, { ids })
    },
    getManyReference: async (resource, originalParams) => {
      return getDataProvider(resource).getManyReference(resource, originalParams)
    },
    create: async (resource, { data }) => {
      return getDataProvider(resource).create(resource, { data })
    },
    update: async (resource, { id, data, previousData }) => {
      return getDataProvider(resource).update(resource, { id, data, previousData })
    },
    updateMany: async (resource, { ids, data }) => {
      return getDataProvider(resource).updateMany(resource, { ids, data })
    },
    delete: async (resource, { id }) => {
      return getDataProvider(resource).delete(resource, { id })
    },
    deleteMany: async (resource, { ids }) => {
      return getDataProvider(resource).deleteMany(resource, { ids })
    },
  }
}
